<template>
  <div class="container-root">
    <AttendanceLog :profile="profile" :id="profile.id" />
  </div>
</template>

<script>
import AttendanceLog from './attendance_log';

export default {
  props: {
    profile: Object
  },
  components: {
    AttendanceLog
  }
};
</script>

<style scoped>
.header-group {
  display: flex;
  justify-content: space-between;
}
.summary-box {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
  margin: 10px 0 10px 0;
  padding: 10px;
}
</style>
